<template>
  <div v-if="user != ''" class="wrapper">
    <HTMLHeader></HTMLHeader>

    <div class="subpage-head-image" style="background-image: url('assets/img/subpage-head.jpg');">
      <div class="container">
        <h1>
          Egyetemi Kutató Ösztöndíj Program
          <span>Hiánypótlás</span>
        </h1>
      </div>
    </div>

    <section v-if="fill_info == '' && hianypotlas_fields.length > 0">
    	<div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">Egyetemi Kutató Ösztöndíj Program hiánypótlás</div>
            <div class="info-box warning" v-if="hianypotlas_megj != ''">{{ hianypotlas_megj }}</div>

            <UploadHandler v-if="hf.hianypotlas.complete == 0" :key="hf.form_field_key" v-for="hf in hianypotlas_fields" :msg="hf.hianypotlas.msg" :max_uploaded_files="hf.hianypotlas.feltoltheto_fajl_db" v-on:change="(value) => { changeValue(value, hf.form_field_key); }" :accepted_files="hf.form_field_key == 'palyazati_adatlap_szerkesztheto' ? 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'image/jpeg,application/pdf,application/x-pdf'" :errors="errors" :id="hf.form_field_key" :label="hf.form_field_name" :name="hf.form_field_key"/>
            <button v-on:click="save" type="button" name="kuld" class="button">Hiánypótlás beküldése</button>
          </div>
        </div>
    	</div>
    </section>

    <section v-if="fill_info != ''">
    	<div class="container">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-title">Egyetemi Kutató Ösztöndíj Program hiánypótlás</div>
            <div class="article-text">
              {{ fill_info }}
            </div>
          </div>
        </div>
      </div>
    </section>

    <HTMLFooter></HTMLFooter>
    <ProfileMenu></ProfileMenu>
  </div>
</template>

<script>
import Vue from 'vue';
import HTMLHeader from '../tpl_header.vue';
import HTMLFooter from '../tpl_footer.vue';
import ProfileMenu from '../tpl_profile_menu.vue';

export default {
  components: {
    HTMLHeader,
    HTMLFooter,
    ProfileMenu
  },
  data: function() {
    return {
      fill_info: '',
      errors: [],
      hianypotlas_fields: [],
      hianypotlas_megj: '',
      form: {
        values: {
        }
      }
    }
  },
  watch: {

  },
  mounted: function() {
  	Vue.nextTick(function() {
      $('.subpage-head-image').height($(window).innerHeight() * .25);
      $(window).scrollTop(0);
      setHeaderDarkLine();

      $(window).resize(function() {
        setHeaderDarkLine();
      });
    });

  	var _this = this;

    this.$root.ajax('form/ekop2024_hianypotlas_lekerdezes/' + this.$route.query.id, {
      success: function(response) {
        if (response.error) {
          _this.fill_info = response.error;
        } else {
          if (response.hianypotlas_fields != undefined) {
            response.hianypotlas_fields.map(function(hf) {
              hf.hianypotlas = JSON.parse(hf.hianypotlas);
              Vue.set(_this.form.values, hf.form_field_key, []);
            });
            _this.hianypotlas_fields = response.hianypotlas_fields;
            _this.hianypotlas_megj = response.hianypotlas_megj;
            if (_this.hianypotlas_fields.length == 0)
              _this.fill_info = 'Önnek nincs szüksége hiánypótlásra.';
          }
          _this.fill_info = response.fill_info;
        }
      }
    });
  },

  methods: {
    save: function() {
      var _this = this;

      this.errors = [];

      this.$root.ajax('form/ekop2024_hianypotlas_mentes/', {
        method: 'POST',
        data: {
          values: JSON.stringify(this.form.values),
          form_id: this.$route.query.id
        },
        success: function(response) {
          if (response.errors != undefined && response.errors.length > 0) {
            _this.errors = response.errors;

            Vue.nextTick(function() {
              $('html, body').animate({
                scrollTop: $('#' + _this.errors[0].id).offset().top - 50
              }, 500);
            })

          } else if (response.error) {
            swal('Hiba!', response.error, 'error');

          } else {
            _this.fill_info = 'Köszönjük. A hiánypótlás beküldése megtörtént.';
          }
        }
      });
    },

    changeValue: function(value, name) {
      this.form.values[name] = value;
    },
  }
}
</script>


// WEBPACK FOOTER //
// ekop2024_hianypotlas.vue?2152ca10